export default [{
	path: '/KeyPointReport/',
	asyncComponent: () => import("@/components/HomePage/KeyPointReport/KeyPointReport.vue"),
	title: "关键指标",
	showAppBar: false,
}, {
	path: '/CapitalReport/',
	asyncComponent: () => import("@/components/HomePage/CapitalReport/CapitalReport.vue"),
	title: "资金",
	showAppBar: false,
}, {
	path: '/ExpensesReport/',
	asyncComponent: () => import("@/components/HomePage/ExpensesReport/ExpensesReport.vue"),
	title: "费用",
	showAppBar: false,
}, {
	path: '/CashReport/',
	asyncComponent: () => import("@/components/HomePage/CashReport/CashReport.vue"),
	title: "纳税情况",
	showAppBar: false,
}, {
	path: '/balanceSheet/',
	asyncComponent: () => import("@/components/HomePage/BalanceSheet/BalanceSheet.vue"),
	title: "资产负债表",
	showAppBar: false,
}, {
	path: '/incomeSheet/',
	asyncComponent: () => import("@/components/HomePage/IncomeSheet/IncomeSheet.vue"),
	title: "利润表",
	showAppBar: false,
}, {
	path: '/incomeSheet3/',
	asyncComponent: () => import("@/components/HomePage/IncomeSheet/IncomeSheet.vue"),
	title: "业务活动表",
	showAppBar: false,
}, {
	path: '/incomeSheet4/',
	asyncComponent: () => import("@/components/HomePage/IncomeSheet/IncomeSheet.vue"),
	title: "盈余及盈余分配表",
	showAppBar: false,
}, {
	path: '/IncomePayReport/',
	asyncComponent: () => import("@/components/HomePage/IncomePayReport/IncomePayReport.vue"),
	title: "往来",
	showAppBar: false,
}, {
	path: '/ServiceState/',
	asyncComponent: () => import("@/components/HomePage/ServiceState/ServiceState.vue"),
	title: "服务进度",
	showAppBar: false,
}, {
	path: '/aaServiceDetail/',
	asyncComponent: () => import("@/components/HomePage/ServiceState/AaServiceDetail.vue"),
	title: "代理记账",
	showAppBar: false,
}, {
	path: '/icServiceDetail/',
	asyncComponent: () => import("@/components/HomePage/ServiceState/IcServiceDetail.vue"),
	title: "工商服务",
	showAppBar: false,
}, {
	path: '/detailAccount/',
	asyncComponent: () => import("@/components/HomePage/DetailAccount/DetailAccount.vue"),
	title: "明细账",
	showAppBar: false,
}, {path: '/SubReport/',
	asyncComponent: () => import("@/components/HomePage/SubReport/SubReport.vue"),
	title: "科目余额表",
	showAppBar: false,
}, {
	path: '/subsidiaryLedger/',
	asyncComponent: () => import("@/components/HomePage/DetailAccount/SubsidiaryLedger.vue"),
	title: "科目明细账",
	showAppBar: false,
}]
